// src/components/AdminRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const AdminRoute = () => {
    const token = localStorage.getItem('adminToken');
    // W przyszłości można dodać weryfikację roli z tokenu, jeśli token zawiera info o roli
    // const decodedToken = jwt_decode(token); // Przykładowo z biblioteki jwt-decode
    // if (token && decodedToken && decodedToken.user && decodedToken.user.role === 'admin') {

    if (token) { // Na razie proste sprawdzenie istnienia tokenu
        return <Outlet />; // Renderuje komponent potomny (np. AdminDashboardPage)
    } else {
        return <Navigate to="/admin/login" replace />; // Przekieruj na stronę logowania
    }
};

export default AdminRoute;